import { cn } from "@/utils";
import HeaderCardPreview from "../Design/headerCard/HeaderCardPreview";

export const HeaderCardOneView = ({
  item,
  onClick,
  size = "large",
}: {
  item: {
    design: { front_proof: string; back_proof: string };
    hcard_design?: { id: string; front_proof: string; back_proof: string };
  };
  onClick: () => void;
  size?: "small" | "large";
}) => {
  const small = size === "small";

  if (!item.hcard_design) return null;

  return (
    <div
      className={cn(
        "relative w-[50px] h-[80px] lg:w-[134px] lg:h-[186px] rounded-lg flex justify-center items-center",
        item.hcard_design.front_proof && "cursor-pointer",
        small
          ? "w-[38px] h-[56px] lg:w-[38px] lg:h-[56px] justify-start pb-2"
          : "lg:bg-[#F6F6F6] lg:border border-[#E8E8E8] lg:p-3"
      )}
      onClick={(item.hcard_design.front_proof && onClick) || undefined}
    >
      {/* {!item.hcard_design.front_proof && allowAddHC && (
        <div className="absolute w-full h-full grid place-items-center z-10">
          <Link
            href={`/create/${orderId}/${item.hcard_design.id}/design`}
            className="h-full w-full grid place-items-center"
          >
            {small ? (
              <Button
                className="flex-col h-full lg:h-full bg-opacity-0 px-0 rounded-md w-full"
                outline
                borderless
              >
                <PlusCircleIcon size={26} />
              </Button>
            ) : (
              <Button
                className="flex-col h-full lg:h-full bg-opacity-0 px-2 rounded-md"
                outline
                borderless
              >
                <PlusCircleIcon size={50} className="hidden lg:block" />
                <PlusCircleIcon size={30} className="lg:hidden" />
                <span className="hidden lg:block">Add Retail Card</span>
              </Button>
            )}
          </Link>
        </div>
      )} */}
      {item.hcard_design.front_proof ? (
        <>
          <HeaderCardPreview
            backImg={item.hcard_design.back_proof}
            frontImg={item.hcard_design.front_proof}
            innerClass="hc_inner--front-flip"
            className="hidden lg:block"
            showDelta={false}
            noFixedHeight
            scale={small ? 0.09 : 0.2}
          />
          <HeaderCardPreview
            backImg={item.hcard_design.back_proof}
            frontImg={item.hcard_design.front_proof}
            innerClass="hc_inner--front-flip"
            className="lg:hidden"
            showDelta={false}
            noFixedHeight
            scale={0.09}
          />
        </>
      ) : (
        <div
          className={cn(
            "w-[50px] h-[80px] rounded-md bg-gray-300",
            small && "h-14 w-[38px]",
            !small && "lg:hidden"
          )}
        />
      )}
      {!small && (
        <div className="hidden lg:flex absolute -top-[14px] -left-2 w-[52px] h-[68px] bg-[#FAFAFA] border border-[#E8E8E8] z-[2] justify-center rounded-lg">
          {item.hcard_design.back_proof ? (
            <HeaderCardPreview
              backImg={item.hcard_design.back_proof}
              frontImg={item.hcard_design.front_proof}
              innerClass="hc_inner--front-flip-full"
              className=" png-drop-shadow-sm"
              showDelta={false}
              noFixedHeight
              scale={0.085}
              onClick={onClick}
            />
          ) : (
            <div className="rounded-md bg-gray-300" />
          )}
        </div>
      )}
    </div>
  );
};
